import { PrimaryColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';
// import { BreakPoints } from '@picsart/rc/enums';

import { Easing } from '@picsart/design-system/foundation/easing';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';

const useStyles = createUseStyles(
  () => ({
    root: {
      padding: [Spacings.s64, Spacings.s0],

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },
    title: {
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      maxWidth: 856,
      margin: [Spacings.s0, 'auto', Spacings.s16],
      fontSize: FontSizes.s30,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',
      lineHeight: LineHeights.l36,
      color: TextColors.tint1,
      overflow: 'hidden',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        lineClamp: 4,
        maxWidth: 456,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        margin: [Spacings.s0, 'auto', Spacings.s24],
        lineClamp: 5,
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },
    link: {
      outline: 'none',

      '&:hover': {
        color: PrimaryColors.base.default,
        transition: `color ${Timings.default} ${Easing.easeInOut}`,
      },
    },
    templateLink: {
      display: 'flex',
      justifyContent: 'flex-end',
      '& > button': {
        border: 0,
        background: 'none',
        marginRight: Spacings.s8,
        fontWeight: FontWeights.medium,
        fontSize: FontSizes.s20,
        lineHeight: LineHeights.l24,
        textDecorationLine: 'underline',
        textTransform: 'capitalize',
        color: TextColors.tint1,

        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          fontSize: FontSizes.s16,
        },
      },
    },

    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gridTemplateRows: 'auto',
      gridGap: Spacings.s24,
      marginTop: Spacings.s24,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridGap: Spacings.s16,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginTop: Spacings.s16,
      },
      // [mediaQuery(766)]: {
      // '@media screen and (max-width: 766px)': {
      //   gridTemplateColumns: 'repeat(2, 1fr)',
      // },
    },
    // Skeleton
    skeletonTitle: {
      extend: 'title',
      maxWidth: 500,
      height: 48,
    },
    skeletonGrid: {
      extend: 'grid',
      '& > i': {
        maxWidth: 304,
        height: 300,
      },
    },
  }),
  {
    name: 'templates',
  },
);

export default useStyles;
